import * as Yup from "yup";

export default () => {
  return Yup.object().shape({
    entitytype: Yup.string()
      .transform((val: any) =>
        typeof val === "string" ? val.toLowerCase() : val,
      )
      .required("Entity type is required"),
    entityType: Yup.string()
      .transform((val: any) =>
        typeof val === "string" ? val.toLowerCase() : val,
      )
      .notRequired(),
    bulkEntityType: Yup.string()
      .transform((val: any) =>
        typeof val === "string" ? val.toLowerCase() : val,
      )
      .notRequired(),

    // single-field creditor/debtor (different name variants)
    creditorname: Yup.string()
      .trim()
      .when("entitytype", {
        is: (val: any) => ["s", "c", "a", "cre"].includes(val),
        then: Yup.string().required("Creditor name is required"),
        otherwise: Yup.string().nullable().notRequired(),
      }),

    debtorname: Yup.string()
      .trim()
      .when("entitytype", {
        is: (val: any) => ["s", "c", "a"].includes(val),
        then: Yup.string().required("Debtor name is required"),
        otherwise: Yup.string().nullable().notRequired(),
      }),

    // bulk fields: validate using bulkEntityType
    bulkCreditorName: Yup.string()
      .trim()
      .when("bulkEntityType", {
        is: (val: any) => ["s", "c", "ar", "cr"].includes(val),
        then: Yup.string().required("Creditor name is required"),
        otherwise: Yup.string().nullable().notRequired(),
      }),
    bulkDebtorName: Yup.string()
      .trim()
      .when("bulkEntityType", {
        is: (val: any) => ["s", "c", "ar"].includes(val),
        then: Yup.string().required("Debtor name is required"),
        otherwise: Yup.string().nullable().notRequired(),
      }),
  });
};
